export default __webpack_public_path__ + "static/media/1792.3135a8f4.png";